import { render } from "./ChevronLeft.vue?vue&type=template&id=85358138"
import script from "./ChevronLeft.vue?vue&type=script&lang=js"
export * from "./ChevronLeft.vue?vue&type=script&lang=js"
script.render = render

export default script